import React, { useCallback, useEffect, useState } from 'react';
import { Rocket, Loader2, RefreshCcw, Send } from 'lucide-react';
import api from '@/lib/axios';

export default function MarketplaceBoostsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [simulado, setSimulado] = useState(true);

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const res = await api.get('/admin/marketplace/boosts');
      setItems(res.data.items || []); setSimulado(res.data.simulado);
    } catch (e) { setErr(e.response?.data?.detail || 'Falha a carregar.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const processar = async (id) => { await api.post(`/admin/marketplace/boosts/${id}/process`); load(); };

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="boosts-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="inline-flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
          <Rocket className="h-5 w-5 text-emerald-600" /> Boosts por email
        </h2>
        <button type="button" onClick={load} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-600">
          <RefreshCcw className="h-3.5 w-3.5" /> Atualizar
        </button>
      </div>
      {simulado && <p className="mt-2 rounded bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700" data-testid="boosts-simulado">Modo simulado — os boosts não enviam emails reais. Alcance é uma estimativa por faixa.</p>}
      {err && <p className="mt-2 text-xs font-semibold text-red-600">{err}</p>}
      {loading ? (
        <p className="mt-4 flex items-center gap-2 text-xs text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> A carregar...</p>
      ) : (
        <ul className="mt-3 space-y-1.5" data-testid="boosts-list">
          {items.length === 0 && <li className="text-xs text-slate-500">Sem boosts. Crie a partir de um anúncio.</li>}
          {items.map((b) => (
            <li key={b.id} className="rounded-lg border border-slate-200 px-3 py-2 text-[11px]">
              <div className="flex items-center justify-between gap-2">
                <span className="font-semibold text-slate-800">{b.titulo || b.listing_id}</span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${b.estado === 'concluido' ? 'bg-emerald-50 text-emerald-700' : 'bg-blue-50 text-blue-700'}`}>{b.estado}</span>
              </div>
              <p className="text-slate-500">Alcance estimado: {b.alcance_estimado_faixa} · Enviados (simulado): {b.enviados_simulados}/{b.total_fila}</p>
              {b.estado !== 'concluido' && (
                <button type="button" onClick={() => processar(b.id)} className="mt-1 inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 px-2.5 py-1 text-[10px] font-semibold text-white" data-testid={`boost-process-${b.id}`}>
                  <Send className="h-3 w-3" /> Processar lote
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
